import { createClient } from '@supabase/supabase-js';

// ProfitYO Supabase configuration.
// The URL and public key must be supplied
// through the application's environment.

const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL?.trim();

const SUPABASE_PUBLIC_KEY = (
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  ''
).trim();

// Fail immediately if configuration is missing.
if (!SUPABASE_URL || !SUPABASE_PUBLIC_KEY) {
  throw new Error(
    'Missing Supabase configuration. ' +
    'Check VITE_SUPABASE_URL and ' +
    'VITE_SUPABASE_ANON_KEY or ' +
    'VITE_SUPABASE_PUBLISHABLE_KEY.'
  );
}

// Detect malformed URLs before initializing.
try {
  const parsedUrl = new URL(SUPABASE_URL);

  if (parsedUrl.protocol !== 'https:' &&
      parsedUrl.hostname !== 'localhost') {
    throw new Error('Supabase URL must use HTTPS.');
  }
} catch {
  throw new Error(
    'Invalid VITE_SUPABASE_URL configuration.'
  );
}

// Create one shared Supabase client.
const supabase = createClient(
  SUPABASE_URL,
  SUPABASE_PUBLIC_KEY,
  {
    auth: {
      // Keep authenticated sessions across refreshes.
      persistSession: true,

      // Refresh expiring access tokens automatically.
      autoRefreshToken: true,

      // Allow Supabase Auth to process callback URLs.
      detectSessionInUrl: true,

      // Preserve the current recovery-event approach.
      // HashRouter callback behavior must be tested.
      flowType: 'implicit'
    }
  }
);

export default supabase;